module.exports = __webpack_public_path__ + "img/mobile_map_chile_urban.c2038a16.svg";